import script from "./UnsubscribeView.vue?vue&type=script&setup=true&lang=js"
export * from "./UnsubscribeView.vue?vue&type=script&setup=true&lang=js"

import "./UnsubscribeView.vue?vue&type=style&index=0&id=adc55168&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adc55168"]])

export default __exports__